import { useState, useEffect } from "react";
import LeafletHistory from "./LeafletHistory";
import LiveLocation from "./LiveLocation";

function MapData() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [viewMode, setViewMode] = useState("history"); 

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await fetch(
          "https://icloud.assetscontrols.com:3443/OpenApi/Admin",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              FTokenID: "3585535a-137c-499e-82ad-af9feff7d8e7",
              FAction: "QueryAdminAssetList",
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.Result === 200) {
          const vehicleList = data.FObject.map((vehicle) => ({
            name: vehicle.FVehicleName || vehicle.FAssetID,
            fguid: vehicle.FGUID,
            assetId: vehicle.FAssetID,
          }));
          setVehicles(vehicleList);
          if (vehicleList.length > 0) {
            setSelectedVehicle(vehicleList[0]);
          }
        } else {
          throw new Error(data.Message || "Failed to fetch vehicles");
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching vehicles:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVehicles();
  }, []);

  const handleVehicleSelect = (vehicle) => {
    setSelectedVehicle(vehicle);
  };

  const toggleViewMode = () => {
    setViewMode((prev) => (prev === "history" ? "live" : "history"));
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
          {loading && <p className="text-gray-500">Loading vehicles...</p>}
          {error && <p className="text-red-500">Error: {error}</p>}

          {!loading && !error && (
            <div className="space-y-4">
              <h2 className="text-lg font-semibold">Select Vehicle</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {vehicles.map((vehicle) => (
                  <button
                    key={vehicle.fguid}
                    onClick={() => handleVehicleSelect(vehicle)}
                    className={`p-4 border rounded-lg text-left transition-colors ${
                      selectedVehicle?.fguid === vehicle.fguid
                        ? "bg-blue-50 border-blue-500"
                        : "hover:bg-gray-50"
                    }`}
                  >
                    <div className="font-medium">{vehicle.name}</div>
                    <div className="text-sm text-gray-500">
                      {vehicle.assetId}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {selectedVehicle && (
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6 space-y-4">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold">
                {viewMode === "history" ? "History View" : "Live Tracking"}
              </h2>
              <button
                onClick={toggleViewMode}
                className="moButtons  text-white px-4 py-2 rounded transition"
              >
                {viewMode === "history"
                  ? "Switch to Live View"
                  : "Switch to History View"}
              </button>
            </div>

            {viewMode === "history" ? (
              <LeafletHistory
                fguid={selectedVehicle.fguid}
                vehicle={selectedVehicle.name}
                key={`history-${selectedVehicle.fguid}`} 
              />
            ) : (
              <LiveLocation
                fguid={selectedVehicle.fguid}
                vehicle={selectedVehicle.name}
                key={`live-${selectedVehicle.fguid}`}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default MapData;
